import React, { useEffect, useMemo, useRef, useState } from "react";
import "./styles.scss";
import { PaginationList } from "types/game";
import { useQuery } from "hooks/useQuery";
import { namePaginationList } from "features/bidding/logic/helper.logic";
import { useTypedSelector } from "store";

interface Props {
  data?: any[];
  currentValue?: string;
  onClickItem?: (val: PaginationList) => void;
}

/**
 * Hook that alerts clicks outside of the passed ref
 */
export function useOutsideAlerter(ref: any, callback?: any) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback && callback();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [callback, ref]);
}

const CustomSelect = ({ data, onClickItem, currentValue }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const params = useQuery();
  const { isComponent } = useTypedSelector((store) => store.game.gameInfoHandPlay);

  useOutsideAlerter(wrapperRef, () => {
    setIsOpen(false);
  });

  return (
    <div
      className="select-custom"
      style={{
        position: "relative",
        justifyContent: isComponent ? "center" : "initial"
      }}
      onClick={() => {
        setIsOpen(!isOpen);
        setTimeout(() => {
          const element = document.getElementById(
            `item-list-select-custom-${Number(currentValue) - 1}`
          );
          if (element) {
            element.scrollIntoView({ behavior: "auto", block: "nearest" });
          }
        }, 0);
      }}
      ref={wrapperRef}>
      <p className="drop-text">{currentValue == "0" ? "" : currentValue}</p>
      {!isComponent && <i className="bi bi-chevron-down drop-arrow"></i>}
      {!isComponent && data && data?.length > 0 && isOpen && (
        <div className="list-select-custom">
          <div
            id="list-select-custom-scroll"
            className="list-select-custom-scroll"
            style={{
              position: "relative",
              overflow: "scroll",
              overflowX: "hidden",
              height: "100%",
              width: "100%"
            }}>
            {data.map((val: PaginationList, index: number) => {
              return (
                <div
                  key={val?.Data?.Id}
                  className="item-list-select-custom"
                  id={`item-list-select-custom-${index}`}
                  onClick={() => onClickItem && onClickItem(val)}>
                  {namePaginationList(params, val, index)}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
